import { ISOCountryCode } from './ISOCountryCode';

export function parseCountryCode(value: string): ISOCountryCode {
  const countryCode = Object.values(ISOCountryCode).find(
    level => value.toUpperCase() === level.toUpperCase(),
  );

  const pmCountryCode = PMCountryCodes[value.toUpperCase()];
  const isoCountryCode = countryCode ?? pmCountryCode;

  if (!isoCountryCode) {
    throw new Error(`Invalid ISO country code: "${value}"`);
  }

  return isoCountryCode;
}

export function isISOCountryCode(value: string): value is ISOCountryCode {
  try {
    parseCountryCode(value);
    return true;
  } catch (err) {
    return false;
  }
}

export function localizedCountryName(value: string, language: string): string {
  try {
    const countryCode = parseCountryCode(value);
    const regionNames = new Intl.DisplayNames([language], {
      type: 'region',
    });
    return regionNames.of(countryCode) ?? countryCode;
  } catch (err) {
    return value.toUpperCase();
  }
}

/**
 * #BecauseWeArePM
 */
const PMCountryCodes: Record<string, ISOCountryCode> = {
  // MPM uses the wrong code for Kosovo
  XZ: ISOCountryCode.Kosovo,

  // Reserved for United Kingdom. The official ISO code is GB
  UK: ISOCountryCode.UnitedKingdom,

  // Deprecated code after name changed from Burma to Myanmar
  BU: ISOCountryCode.Myanmar,
};
